var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXCircleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zM4.837 6.05L6.745 7.96 4.837 9.867c-.808.808.404 2.02 1.212 1.212l1.908-1.908 1.908 1.908c.809.808 2.02-.404 1.213-1.212L9.168 7.959l1.909-1.908c.808-.809-.404-2.02-1.213-1.213L7.957 6.747 6.05 4.838c-.808-.808-2.02.405-1.212 1.213z",
    fill: "#EB5757"
  })));
}

export default SvgXCircleRed;